const WEIGHTS = {
	thin: 'w1',
	extraLight: 'w2',
	light: 'w3',
	regular: 'w4',
	medium: 'w5',
	semiBold: 'w6',
	bold: 'w7',
	extraBold: 'w8',
}

export const getWeight = ({weight, bold, semiBold}) => {
	weight = WEIGHTS[weight]

	// Historically, we have been assigning incorrect weights with to the 'bold' and 'semiBold' boolean props.
	// Since it is impactful to change, keep this mapper for now.
	if (bold) return WEIGHTS.semiBold
	if (semiBold) return WEIGHTS.medium

	if (weight) return weight
}
